var map = {
	"./0_Dusty.mp3": "a7c9",
	"./3_Tom.mp3": "2a91",
	"./4_Lisa.mp3": "2448",
	"./M_Brilliant.mp3": "989f",
	"./M_Excellent.mp3": "71e7",
	"./M_Fantastic.mp3": "5100",
	"./M_Great.mp3": "55e8",
	"./M_Perfect.mp3": "4777",
	"./M_Think again.mp3": "5da2",
	"./M_Try again.mp3": "9dd3",
	"./M_Very good.mp3": "0aa7",
	"./M_Well done.mp3": "993e",
	"./M_Work harder.mp3": "8e29",
	"./click.mp3": "b933"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ead";